export default class GridEndpointService {

  static getUrl(endpoint, props, state) {
    const endpointType = typeof (endpoint);
    switch (endpointType) {
      case 'string':
        return endpoint;
      case 'function':
        return endpoint(props, state);
      default:
        throw  new Error('endpointType not has implementation');
    }
  }

}



// WEBPACK FOOTER //
// ./src/customGrid/GridEndpointService.js